import React from "react";
import moment from "moment";
import { safeText } from "../utils/hubHelpers";

export default function AssetTableView({
  items = [],
  onInspect,
  onLogReading,
  onChangeStatus,
  onAddService,
  onEdit,
  onTransfer,
}) {
  const safeItems = Array.isArray(items) ? items : [];

  return (
    <div style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
        <thead>
          <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0", color: "#64748b", textTransform: "uppercase", fontSize: "11.5px", letterSpacing: "0.04em" }}>
            <th style={{ padding: "0.85rem 1rem", textAlign: "left", fontWeight: 700 }}>Machine / Asset</th>
            <th style={{ padding: "0.85rem 1rem", textAlign: "left", fontWeight: 700 }}>Site Location</th>
            <th style={{ padding: "0.85rem 1rem", textAlign: "left", fontWeight: 700 }}>Registration No</th>
            <th style={{ padding: "0.85rem 1rem", textAlign: "left", fontWeight: 700 }}>Fuel / Type</th>
            <th style={{ padding: "0.85rem 1rem", textAlign: "left", fontWeight: 700 }}>Status</th>
            <th style={{ padding: "0.85rem 1rem", textAlign: "left", fontWeight: 700 }}>Next Service</th>
            <th style={{ padding: "0.85rem 1rem", textAlign: "right", fontWeight: 700 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {safeItems.length === 0 ? (
            <tr>
              <td colSpan={7} style={{ padding: "2rem", textAlign: "center", color: "#94a3b8", fontSize: "13px" }}>
                No machinery found matching the criteria.
              </td>
            </tr>
          ) : (
            safeItems.map((item) => {
              const isBreakdown = item?.status === "Breakdown";
              const isUnderService = item?.status === "Under Service" || item?.status === "In Service";
              const isIdle = item?.status === "Idle";
              const statusLabel = safeText(item?.status, "Operational");

              const badgeColor = isBreakdown
                ? "#dc2626"
                : isUnderService
                ? "#d97706"
                : isIdle
                ? "#64748b"
                : "#059669";
              const badgeBg = isBreakdown
                ? "#fee2e2"
                : isUnderService
                ? "#fef3c7"
                : isIdle
                ? "#f1f5f9"
                : "#dcfce7";

              return (
                <tr key={item?.id || Math.random()} style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "0.85rem 1rem", textAlign: "left" }}>
                    <div style={{ fontWeight: 700, color: "#0f172a", fontSize: "13.5px", textAlign: "left" }}>{safeText(item?.name, "Machine")}</div>
                    <div style={{ fontSize: "12px", color: "#64748b", textAlign: "left" }}>
                      {safeText(item?.assetNo, "—")} {item?.model ? `• ${safeText(item.model)}` : ""}
                    </div>
                  </td>
                  <td style={{ padding: "0.85rem 1rem", color: "#334155", fontWeight: 500, fontSize: "13px", textAlign: "left" }}>
                    {safeText(item?.Site?.name || item?.Site, "Unassigned")}
                  </td>
                  <td style={{ padding: "0.85rem 1rem", color: "#0f172a", fontWeight: 600, fontSize: "13px", textAlign: "left" }}>
                    {safeText(item?.machineNumber, "—")}
                  </td>
                  <td style={{ padding: "0.85rem 1rem", color: "#475569", fontSize: "13px", textAlign: "left" }}>
                    {safeText(item?.fuelType || item?.type, "—")}
                  </td>
                  <td style={{ padding: "0.85rem 1rem", textAlign: "left" }}>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 4,
                        padding: "3px 8px",
                        borderRadius: 12,
                        fontSize: "12px",
                        fontWeight: 700,
                        color: badgeColor,
                        background: badgeBg,
                      }}
                    >
                      ● {statusLabel}
                    </span>
                  </td>
                  <td style={{ padding: "0.85rem 1rem", color: "#334155", fontSize: "13px", textAlign: "left" }}>
                    {item?.nextServiceDate ? moment(item.nextServiceDate).format("DD MMM YYYY") : "—"}
                  </td>
                  <td style={{ padding: "0.85rem 1rem", textAlign: "right" }}>
                    <div style={{ display: "inline-flex", gap: "0.4rem", flexWrap: "wrap", justifyContent: "flex-end" }}>
                      <button
                        type="button"
                        onClick={() => onLogReading?.(item)}
                        style={{ padding: "5px 9px", fontSize: "13px", border: "1px solid #e2e8f0", borderRadius: 6, background: "#fff", cursor: "pointer", fontWeight: 600 }}
                        title="Log Meter"
                      >
                        ⏱
                      </button>
                      <button
                        type="button"
                        onClick={() => onAddService?.(item)}
                        style={{ padding: "5px 9px", fontSize: "13px", border: "1px solid #e2e8f0", borderRadius: 6, background: "#fff", cursor: "pointer", fontWeight: 600 }}
                        title="Service"
                      >
                        🔧
                      </button>
                      <button
                        type="button"
                        onClick={() => onTransfer?.(item)}
                        style={{ padding: "5px 9px", fontSize: "13px", border: "1px solid #bfdbfe", borderRadius: 6, background: "#eff6ff", color: "#2563eb", cursor: "pointer", fontWeight: 600 }}
                        title="Transfer"
                      >
                        🔁
                      </button>
                      <button
                        type="button"
                        onClick={() => onEdit?.(item)}
                        style={{ padding: "5px 9px", fontSize: "13px", border: "1px solid #cbd5e1", borderRadius: 6, background: "#fff", cursor: "pointer", fontWeight: 600 }}
                        title="Edit Machine"
                      >
                        ✏️
                      </button>
                      <button
                        type="button"
                        onClick={() => onInspect?.(item)}
                        style={{ padding: "5px 12px", fontSize: "13px", border: "1px solid #0f172a", borderRadius: 6, background: "#0f172a", color: "#fff", cursor: "pointer", fontWeight: 600 }}
                      >
                        Open ↗
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
